import { GetCashbackTC, GetCashbackTermsTC, GetCashbackCalculatedTimeTC } from './cashback.thunks'

const cashbackAsyncActions = {
  GetCashbackTC,
  GetCashbackTermsTC,
  GetCashbackCalculatedTimeTC,
}

export default cashbackAsyncActions
